// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__UnqMl","vLegacy":"SelectSecondary_vLegacy__21Aen","error":"SelectSecondary_error__3RWCy","disabled":"SelectSecondary_disabled__3G_2u"};